exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".answerCircle{width:5.2rem;height:5.2rem;border:1px solid #ddd;border-radius:5.2rem;display:inline-block}.answerCircle .answerIcon{width:3rem;height:3rem;margin:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/icons/answer_circle.scss
// module id = 1475
// module chunks = 0